import React, { useState, useEffect } from "react";
import { Form, Button, FormControl, InputGroup } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { getBalance } from "../../services/Balance/balanceService";

const BalanceInput = ({ value, onChange, label, isInvalid, userRoles, btnUserRoles }) => {
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setInputValue(value !== undefined && value !== null ? value.toString() : "");
  }, [value]);

  const formatBalance = (input) => {
    if (!input) return "";

    input = input.replace(",", ".");

    input = input.replace(/[^0-9.]/g, "");

    const parts = input.split(".");
    if (parts.length > 2) {
      input = parts[0] + "." + parts.slice(1).join("");
    }

    if (/^0[0-9]/.test(input)) {
      input = input.replace(/^0+/, "");
    }
    if (input.startsWith(".")) {
      input = "";
    }

    if (parts.length === 2 && parts[1].length > 3) {
      parts[1] = parts[1].substring(0, 3);
      input = parts.join(".");
    }

    return input;
  };

  const handleInputChange = (e) => {
    const formattedValue = formatBalance(e.target.value);
    setInputValue(formattedValue);
    onChange(formattedValue);
  };

  const handleBlur = () => {
    if (inputValue.includes(".")) {
      const formattedBalance = parseFloat(inputValue).toFixed(3);
      setInputValue(formattedBalance);
      onChange(formattedBalance);
    }
  };

  const fetchAndSetBalance = async () => {
    setLoading(true);
    try {
      const fetchedBalance = await getBalance();
      const formattedBalance = formatBalance(fetchedBalance.toString());
      setInputValue(formattedBalance);
      onChange(formattedBalance);
    } catch (error) {
      console.error("Erro ao comunicar com a balança:", error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mb-3">
      {label && <Form.Label className="mb-1">{label}</Form.Label>}
      <InputGroup className={isInvalid ? "is-invalid" : ""}>
        <FormControl
          placeholder="Pesagem"
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleBlur}
          readOnly={userRoles}
          className={isInvalid ? "is-invalid" : ""}
          autoComplete='off'
        />
        <Button
          variant="outline-secondary"
          onClick={fetchAndSetBalance}
          disabled={loading || btnUserRoles}
        >
          {loading ? "Carregando..." : <FaSearch />}
        </Button>
      </InputGroup>
      {isInvalid && <div className="invalid-feedback">{label} é obrigatório.</div>}
    </div>
  );
};

export default BalanceInput;